import React from "react";

const EnquiresCheckBox = ({ idName, labelTitle }) => {
  return (
    <>
      <div className="form-check form-check-inline">
        <div className="custom-control custom-radio">
          <input  type="radio"  id={idName}  name="inlineRadioOptions" className="custom-control-input"/>
          <label className="custom-control-label" htmlFor={idName}>{labelTitle}</label>
        </div>
      </div>
    </>
  )
}

export default EnquiresCheckBox;
